import { dayjs } from "~/utils/dayjs";

/**
 * Formats a date to DD/MM/YY HH:mm
 *
 * @param {*} value expressions value (result of former chain)
 */
export default (value) => (value ? dayjs(value).format("DD/MM/YYYY HH:mm") : "");
